import { useCallback, useEffect, useState } from 'react';
import styles from './index.module.scss';

interface ICookiesPopup {
	link: string;
}

const COOKIE_NAME = 'cookiesAccepted';
const COOKIES_ACCEPTED_EVENT = 'cookiesAccepted';

const CookiesPopup = ({ link }: ICookiesPopup) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);

	const getCookie = useCallback((name: string): string | null => {
		const cookieName = name + '=';
		const cookiesArr = document.cookie.split(';');
		for (let cookie of cookiesArr) {
			const trimmedCookie = cookie.trim();
			if (trimmedCookie.indexOf(cookieName) === 0) {
				return trimmedCookie.substring(cookieName.length);
			}
		}
		return null;
	}, []);

	const setCookie = (name: string, value: string, days: number): void => {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		const expires = 'expires=' + date.toUTCString();
		document.cookie = `${name}=${value};${expires};path=/`;
	};

	useEffect(() => {
		const cookiesAccepted = getCookie(COOKIE_NAME);

		if (!cookiesAccepted) {
			setIsVisible(true);
		}
	}, [getCookie]);

	const handleAcceptCookies = () => {
		setCookie(COOKIE_NAME, 'true', 365);
		setIsVisible(false);

		window.dispatchEvent(new Event(COOKIES_ACCEPTED_EVENT));
	};

	if (!isVisible) return null;

	return (
		<div className={styles.cookiesPopup}>
			<div className={styles.cookiesPopup__content}>
				<p className={styles.cookiesPopup__text}>
					На&nbsp;этом сайте используются файлы cookie. Они помогают нам
					улучшать сайт и&nbsp;ваше взаимодействие с&nbsp;ним.&nbsp;
					<a
						href={link}
						target='_blank'
						rel='noreferrer'
						className={styles.cookiesPopup__link}
					>
						Подробнее
					</a>
				</p>
			</div>
			<button
				className={styles.cookiesPopup__button}
				onClick={handleAcceptCookies}
			>
				ОК
			</button>
		</div>
	);
};

export default CookiesPopup;
